import React from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { pl } from "date-fns/locale";
import AlertsHandler from "./shared/AlertsHandler";
import { BrowserRouter, Switch } from "react-router-dom";
import Routing from "./Routing";
import useTheme from "./themeHook";
import { ThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core";

const App: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [, , theme] = useTheme();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={pl}>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Switch>
              <React.Fragment>
                <Routing />
              </React.Fragment>
            </Switch>
            <AlertsHandler />
          </BrowserRouter>
        </ThemeProvider>
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

export default App;
